import React, { useRef, useEffect, useState } from 'react';
import { TableLayout } from '~components';
import { GaraForm } from './gara-form';
import GaraFields from './fields-data';
import { Input, Button, Popconfirm, message } from 'antd';

import ApiServices from '~services';

const Gara = () => {
  const defaultTabPanels = [
    {
      title: 'Detail',
      content: 'detail content',
    },
  ];
  const [loading, setLoading] = useState(false);
  const [isLoadingTab, setIsLoadingTab] = useState(false);
  const [selected, setSelected] = useState('');
  const [garas, setGaras] = useState([]);
  const [tabPanels, setTabPanels] = useState(defaultTabPanels);
  const [titleTab, setTitleTab] = useState('');
  const [fields, setFields] = useState({});
  console.log(fields);
  //-------------------------------------------------------------------
  const [searchTerm, setSearchTerm] = useState('');
  const typingTimeoutref = useRef(null);
  //-------------------------------------------------------------------
  const [searchByColumn, setSearchByColumn] = useState({
    code: '',
    name: '',
    phone: '',
    address: '',
    fax: '',
    contactPerson: '',
    companyName: '',
  });

  const getGaras = async () => {
    let dataFilterSend = { ...filter };
    if (Object.keys(dataFilterSend.Columns).length === 0) {
      delete dataFilterSend['Columns'];
    } else {
      const columnJSONSTRING = JSON.stringify(dataFilterSend.Columns);
      dataFilterSend.Columns = columnJSONSTRING;
    }

    try {
      setLoading(true);
      let { data } = await ApiServices.getGara(dataFilterSend);
      setLoading(false);
      let pag = pagination;
      pag.total = data?.totalRecords || 0;
      data = data?.data || [];
      setGaras(data);
      setPagination(pag);
    } catch (error) {
      console.log('Error - get cars', error);
      console.error(error);
    }
  };

  useEffect(() => {
    getGaras();
  }, []);

  //----------- Start ----- Pagination Search ---------
  //----------- Pagination --------------------------
  const onChangePagination = (value) => {
    let filterTemp = filter;
    filterTemp.PageNumber = value;
    setFilter(filterTemp);
    // searchCarsByColumn();
    getGaras();
  };
  const [pagination, setPagination] = useState({
    total: 1,
    showSizeChanger: false,
    onChange: onChangePagination,
  });
  const [filter, setFilter] = useState({
    PageNumber: 0,
    PageSize: 10,
    Text: '',
    Columns: '',
    // QueryField: '',
    // SortColumn: '',
    // SortColumnDirection: ''
  });

  // ------------ Search Text ------------------------
  const handleSearchTermChange = (e) => {
    const val = e.target.value;
    setSearchTerm(val);
    const filterTmp = filter;
    filterTmp.Text = val;

    if (typingTimeoutref.current) {
      clearTimeout(typingTimeoutref.current);
    }

    typingTimeoutref.current = setTimeout(() => {
      if (val.length > 2) {
        filter.PageNumber = 1;
        setFilter(filterTmp);
        getGaras();
      }
      if (val.length === 0) {
        setFilter(filterTmp);
        getGaras();
      }
    }, 1000);
  };
  // ------------ Search Column ----------------------
  const handleSearchColumnFn = (event, name) => {
    const filterTmp = filter;
    const val = event.target.value;
    let _searchByColumn = { ...searchByColumn };
    _searchByColumn[`${name}`] = val;
    setSearchByColumn(_searchByColumn);
    // Clear timeout
    if (typingTimeoutref.current) {
      clearTimeout(typingTimeoutref.current);
    }
    typingTimeoutref.current = setTimeout(() => {
      if (val.length > 0) {
        filter.PageNumber = 1;
        let searchColumnFn = { ...filter.Columns };
        searchColumnFn[`${name}`] = val;
        filter.Columns = searchColumnFn;

        setFilter(filterTmp);
        getGaras();
      }
      if (val.length === 0) {
        delete filter.Columns[`${name}`];
        setFilter(filterTmp);
        getGaras();
      }
    }, 1000);
  };
  // ------------- End Search --------------------

  const setFieldsForm = async (value) => {
    const garaFields = await GaraFields(value);
    await setFields(garaFields);
    return garaFields;
  };
  const reload = async () => {
    setSelected(null);
    await getGaras();
  };

  const getUpdatedGaraForm = async (value, isNew = false, id = null, dataSelected) => {
    const garaForm = await (
      <GaraForm
        fields={value}
        setLoading={setIsLoadingTab}
        isNew={isNew}
        id={id}
        reload={reload}
        onChange={setFields}
        dataSelected={dataSelected}
      />
    );
    return setTabPanels([
      {
        title: 'Thông Tin Chi Tiết',
        content: garaForm,
      },
    ]);
  };

  const onRowSelected = async (value) => {
    await setIsLoadingTab(true);
    await setTitleTab(value.code);
    await setFieldsForm(value)
      .then((res) => {
        return getUpdatedGaraForm(res, false, value.id, value);
      })
      .then(() => setSelected(value));
    setIsLoadingTab(false);
  };
  const deleteGara = async (record) => {
    try {
      const res = await ApiServices.deleteGara(record.id);
      if (res.data) {
        message.success('Xoá Gara thành công');
        return reload();
      }
      message.error('Xoá Gara thất bại, vui lòng thử lại sau!');
    } catch (error) {
      console.log(error);
    }
  };

  const columns = [
    {
      // title: 'Mã Gara',
      title: (
        <span style={{ textAlign: 'center' }}>
          <div>Mã</div>
          <hr />
          <Input
            placeholder='Search'
            allowClear
            value={searchByColumn.code}
            onChange={(event) => handleSearchColumnFn(event, 'code')}
          />
        </span>
      ),
      dataIndex: 'code',
      width: 150,
      render: (value, record) => (
        <a onClick={() => onRowSelected(record)}>{value || 'underFine'}</a>
      ),
    },
    {
      // title: 'Tên Gara',
      title: (
        <span style={{ textAlign: 'center' }}>
          <div>Tên Gara</div>
          <hr />
          <Input
            placeholder='Search'
            allowClear
            value={searchByColumn.name}
            onChange={(event) => handleSearchColumnFn(event, 'name')}
          />
        </span>
      ),
      width: 150,
      dataIndex: 'name',
    },
    {
      // title: 'SĐT',
      title: (
        <span style={{ textAlign: 'center' }}>
          <div>SĐT</div>
          <hr />
          <Input
            placeholder='Search'
            allowClear
            value={searchByColumn.phone}
            onChange={(event) => handleSearchColumnFn(event, 'phone')}
          />
        </span>
      ),
      width: 150,
      dataIndex: 'phone',
    },
    {
      // title: 'Địa Chỉ',
      title: (
        <span style={{ textAlign: 'center' }}>
          <div>Địa Chỉ</div>
          <hr />
          <Input
            placeholder='Search'
            allowClear
            value={searchByColumn.address}
            onChange={(event) => handleSearchColumnFn(event, 'address')}
          />
        </span>
      ),
      width: 200,
      dataIndex: 'address',
    },
    {
      // title: 'Fax',
      title: (
        <span style={{ textAlign: 'center' }}>
          <div>Fax</div>
          <hr />
          <Input
            placeholder='Search'
            allowClear
            value={searchByColumn.fax}
            onChange={(event) => handleSearchColumnFn(event, 'fax')}
          />
        </span>
      ),
      width: 150,
      dataIndex: 'fax',
    },
    {
      // title: 'Người Liên Hệ',
      title: (
        <span style={{ textAlign: 'center' }}>
          <div>Người Liên Hệ</div>
          <hr />
          <Input
            placeholder='Search'
            allowClear
            value={searchByColumn.contactPerson}
            onChange={(event) => handleSearchColumnFn(event, 'contactPerson')}
          />
        </span>
      ),
      width: 150,
      dataIndex: 'contactPerson',
    },
    {
      // title: 'Công Ty',
      title: (
        <span style={{ textAlign: 'center' }}>
          <div>Công Ty</div>
          <hr />
          <Input
            placeholder='Search'
            allowClear
            value={searchByColumn.companyName}
            onChange={(event) => handleSearchColumnFn(event, 'companyName')}
          />
        </span>
      ),
      width: 150,
      dataIndex: 'companyName',
    },
    {
      title: 'Action',
      fixed: 'right',
      width: 75,
      render: (record) => (
        <Popconfirm
          onConfirm={() => deleteGara(record)}
          title='Xoá Gara này？'
          okText='Yes'
          cancelText='No'
        >
          <a href='#'>Xoá</a>
        </Popconfirm>
      ),
    },
  ];

  const createGara = async () => {
    await setTitleTab('');
    await setFieldsForm({})
      .then((res) => getUpdatedGaraForm(res, true))
      .then(() => setSelected({ isNew: true }));
    await setIsLoadingTab(false);
  };

  const headerContent = (
    <>
      <Button type='primary' onClick={createGara}>
        Thêm Mới
      </Button>
      <Input.Search
        style={{ width: '200px' }}
        className='mg-l-15'
        placeholder='Search'
        value={searchTerm}
        onChange={handleSearchTermChange}
      />
    </>
  );
  return (
    <TableLayout
      rowKey='id'
      columns={columns}
      data={garas}
      loading={loading}
      selected={selected}
      closeDrawer={() => setSelected(null)}
      isLoadingTab={isLoadingTab}
      headerContent={headerContent}
      titleTab={titleTab}
      tabPanels={tabPanels}
      pagination={pagination}
      isDisplayCheckbox={false}
    />
  );
};

export { Gara };
